export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">投稿爆料</h2>
          <p className="text-sm text-foreground-500">你有猛料？我们帮你发声</p>
        </div>

        <div className="bg-background-50 rounded-lg p-6 md:p-10">
          <div className="flex flex-col md:flex-row gap-8">
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-foreground-900 mb-4">爆料须知</h3>
              <ul className="space-y-3 text-sm text-foreground-600">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>请提供尽可能详细的爆料信息，包括时间、地点、人物和事件经过</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>如有图片、视频或录音等证据材料，请一并附上</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>我们严格保护爆料人隐私，支持完全匿名投稿</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>编辑团队将在24小时内审核并回复</span>
                </li>
              </ul>
            </div>

            <div className="flex-1">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">爆料标题</label>
                  <input type="text" className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors" placeholder="请简要描述爆料内容" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">详细描述</label>
                  <textarea className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none" rows={4} placeholder="请详细描述事件经过（限500字）" maxLength={500}></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">联系方式（选填）</label>
                  <input type="text" className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors" placeholder="邮箱或社交媒体账号，方便我们联系你" />
                </div>
                <button className="w-full px-6 py-3 rounded-md bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-send-plane-line mr-2"></i>
                  提交爆料
                </button>
                <p className="text-xs text-foreground-400 text-center">提交即表示你同意我们的爆料条款和隐私政策</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}